import { ILoginRequest, ISignupRequest } from "../modals/auth.modal";
import ApiService from "./api.service";
import axiosAuth from "./axios-interceptor";


class AuthService {

    registration(signupRequest: ISignupRequest) {
        return axiosAuth.post(`${ApiService.Auth}/register`, signupRequest);
    }

    login(loginRequest: ILoginRequest) {
        return axiosAuth.post(`${ApiService.Auth}/login`, loginRequest);
    }
    
}

export default new AuthService();
